import { useContext, useLayoutEffect, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { AppTool } from "@/utils/app-tool";
import { api } from "@/utils";
import { LiffNavBtn, LiffListItemBtn } from "@/components";
import { ProfileCardCarousel } from "./ProfileCardCarousel";
import { StoreConsultant } from "./StoreConsultant";
import { LiffContext } from "@/utils";
import ReactGA from "react-ga4";
import "./index.sass";
import "swiper/css";
import "swiper/css/pagination";

// img
import HomeBg from "@/assets/img/liff/home/home_bg.png";
import BtnCloss from "@/assets/img/liff/btn-closs.png";

const HomePage = () => {
	const location = useLocation();
	const [popupsImage, setPopupsImage] = useState("");
	const [bannerList, setbannerList] = useState([]);
	const [memberConsultant, setMemberConsultant] = useState(null);
	const { liffActions } = useContext(LiffContext);
	const [sliderList, setSliderList] = useState([]);
	const [showRegistrationModal, setShowRegistrationModal] = useState(false);
	const [showNoRegistrationModal, setShowNoRegistrationModal] = useState(false);
	const [selectedSlide, setSelectedSlide] = useState(null);

	const getSlider = async () => {
		try {
			const response = await fetch('https://linebot-dev.s3.ap-northeast-1.amazonaws.com/tnf-member/Mountain/slider.json');
			const data = await response.json();
			const now = new Date();
			
			// 過濾出在有效時間範圍內的輪播項目
			const validSlides = data.filter(slide => {
				const sliderStartDate = new Date(slide.sliderStartTime * 1000);
				const sliderEndDate = new Date(slide.sliderEndTime * 1000);
				
				// 檢查輪播時間是否在有效範圍內
				const isSliderValid = now >= sliderStartDate && now <= sliderEndDate;
			
				return isSliderValid;
			});

			if (validSlides.length) {
				setSliderList(validSlides.map(slide => ({
					imageUrl: slide.imageUrl,
					description: slide.description,
					targetUrl: slide.targetUrl,
					communityUrl: slide.communityUrl,
					registrationStartTime: slide.registrationStartTime,
					registrationEndTime: slide.registrationEndTime,
					isRegistrationOpen: slide.isRegistrationOpen
				})));
			}
		} catch (error) {
			console.error("獲取輪播圖片失敗", error);
		}
	};

	const handleSliderClick = (slide) => {
		const now = new Date();
		const registrationStartDate = new Date(slide.registrationStartTime * 1000);
		const registrationEndDate = new Date(slide.registrationEndTime * 1000);
		
		// 檢查是否在報名時間範圍內
		const isRegistrationValid = now >= registrationStartDate && now <= registrationEndDate;
		
		if (isRegistrationValid) {
			// 允許報名，顯示提示彈窗
			setSelectedSlide(slide);
			setShowRegistrationModal(true);
		} else {
			// 不允許報名，顯示提示彈窗
			setSelectedSlide(slide);
			setShowNoRegistrationModal(true);
		}
	};

	const getMemberConsultant = async () => {
		liffActions.setShowFullPageLoader(true);
		try {
			const res = await api(5).get("/get_crm_member_consultant");
			const member_consultant = res.data;
			setMemberConsultant(member_consultant);
		} catch (error) {
			console.error("Get Member Line Failed", error);
		} finally {
			liffActions.setShowFullPageLoader(false);
		}
	};

	const getPopup = async () => {
		const res = await api().get("/get_ad_popup");
		if (res.data && res.data.image) {
			setPopupsImage(res.data.image);
			AppTool.openDialog(".cHomeAdDialog");
		}
	};

	const getBanner = async () => {
		const res = await api().get("/get_ad_banner");
		if (res.data) {
			setbannerList(res.data);
		}
	};

	useLayoutEffect(() => {
		liffActions.setShowFullPageLoader(true);
	}, [location.pathname]);

	useEffect(() => {
		AppTool.processActivityTnfRedirectUrl();
		getMemberConsultant();
		getPopup();
		getBanner();
		getSlider();
		ReactGA.event("page_home");
	}, []);

	return (
		<>
			{/* 允許報名彈窗 */}
			{showRegistrationModal && (
				<div
					role="presentation"
					className="fixed left-0 top-0 z-[100] h-[110vh] w-[100vw] flex-col items-center justify-center duration-500"
					style={{ display: "flex", marginTop: "0" }}
					onClick={() => setShowRegistrationModal(false)}
				>
					<div className="absolute z-[0] size-[100%] bg-[#000] opacity-[0.8]" />
					<div
						role="presentation"
						className="relative z-[1] w-[70vw] min-h-[40vw] text-white bg-transparent border-[1vw] border-white rounded-lg p-3 flex items-center justify-center"
						onClick={(e) => e.stopPropagation()}
					>
						<div>
							<div className="title mb-3 text-lg whitespace-pre text-center font-[800]">提醒您</div>
							<div className="subtitle text-sm whitespace-pre text-center">
								本活動採抽籤制<br/>
								報名不代表錄取成功
							</div>
							<div className="subtitle text-sm whitespace-pre text-center mt-2">
								參與活動行程需具備基本體能<br/>
								請您評估自身健康狀況後再行報名
							</div>
						</div>
					</div>
					<div className="text-center">
						<button 
							type="button" 
							className="confirm-btn relative mx-auto my-4 bg-white rounded-lg" 
							onClick={() => {
								window.open(selectedSlide?.targetUrl, '_blank');
								setShowRegistrationModal(false);
							}}
						>
							<div className="title text-[4vw] text-black text-center py-[1.5vw] px-[15vw] font-[800]">我已閱讀並同意以上提醒 ▶</div>
						</button>
					</div>
				</div>
			)}

			{/* 不允許報名彈窗 */}
			{showNoRegistrationModal && (
				<div
					role="presentation"
					className="fixed left-0 top-0 z-[100] h-[110vh] w-[100vw] flex-col items-center justify-center duration-500"
					style={{ display: "flex", marginTop: "0" }}
					onClick={() => setShowNoRegistrationModal(false)}
				>
					<div className="absolute z-[0] size-[100%] bg-[#000] opacity-[0.8]" />
					<div
						role="presentation"
						className="relative z-[1] w-[60vw] min-h-[40vw] text-white bg-transparent border-[1vw] border-white rounded-lg p-3 flex items-center justify-center"
						onClick={(e) => e.stopPropagation()}
					>
						<div>
							<div className="title mb-3 text-lg whitespace-pre text-center font-[800]">活動尚未開放報名！</div>
							<div className="subtitle text-lg whitespace-pre text-center">
								📅 各場次開放時間<br/>
								將公告在社群／門市<br/>
								記得關注喔！
							</div>
						</div>
					</div>
					<div className="text-center">
						<button 
							type="button" 
							className="confirm-btn relative mx-auto my-4 bg-white rounded-lg" 
							onClick={() => {
								window.open(selectedSlide?.communityUrl, '_blank');
								setShowNoRegistrationModal(false);
							}}
						>
							<div className="title text-[4vw] text-black text-center py-[1.5vw] px-[15vw] font-[800]">了解詳情 ▶</div>
						</button>
					</div>
				</div>
			)}

			<div
				role="presentation"
				className="cHomeAdDialog fixed left-0 top-0 z-[100] h-[110vh] w-[100vw] flex-col items-center justify-center duration-500"
				style={{ display: "none", marginTop: "0" }}
				onClick={() => {
					AppTool.closeDialog(".cHomeAdDialog");
				}}
			>
				<div className="cMask absolute z-[0] size-[100%] bg-[#000] opacity-[0.5]" />
				<div
					role="presentation"
					className="cDialog relative z-[1] mt-[-20vw] w-[80vw] rounded-[1vw] p-[1vw] duration-500"
					style={{ transform: "scale( 0 )" }}
				>
					<img className="w-[100%]" src={popupsImage || ""} />
					<img
						className="absolute right-[1vw] top-[1vw] size-[6vw]"
						src={BtnCloss}
					/>
				</div>
			</div>
			<div className="cHomePage h-screen w-full bg-gray-50">
				<div className="flex w-full flex-col">
					{/* 背景 */}
					<div className="absolute flex h-auto w-full">
						<img
							src={HomeBg}
							alt=""
							className="h-auto w-full object-fill object-top"
							loading="lazy"
						/>
					</div>

					<ProfileCardCarousel />

					<StoreConsultant memberConsultant={memberConsultant} />

					{/* 前往點數歷程及基本資料btn */}
					<div className="flex justify-center p-4 px-0">
						<div className="flex w-full">
							<LiffNavBtn
								iconName="PointList"
								title="點數歷程"
								linkTo="/points"
							></LiffNavBtn>
							<hr className="h-full border-l border-solid border-[#0000001f]" />
							<LiffNavBtn
								iconName="ShoppingOrder"
								title="消費紀錄"
								linkTo="/orders"
							></LiffNavBtn>
							<hr className="h-full border-l border-solid border-[#0000001f]" />
							<LiffNavBtn
								iconName="Profile"
								title="基本資料"
								linkTo="/profile"
							></LiffNavBtn>
						</div>
					</div>
					{/*Banner*/}
					<div
						className="mt-4"
						style={{ display: bannerList.length > 0 ? "block" : "none" }}
					>
						<Swiper
							initialSlide={0}
							pagination={true}
							modules={[Autoplay, Pagination]}
							loop={true}
							autoplay={{
								delay: 5000,
								disableOnInteraction: false,
							}}
							className="cSwiper"
						>
							{bannerList.map((row, index) => (
								<SwiperSlide key={index}>
									<img
										src={row.image}
										alt=""
										className="h-auto w-full"
										loading="lazy"
									/>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
					<div className="mt-4">
						{sliderList.length > 0 && (
							<Swiper
								initialSlide={0}
								pagination={true}
								modules={[Autoplay, Pagination]}
								loop={true}
								autoplay={{
									delay: 5000,
									disableOnInteraction: false,
								}}
								className="cSwiper"
							>
								{sliderList.map((row, index) => (
									<SwiperSlide key={index}>
										<img 
											src={row.imageUrl} 
											alt={row.description} 
											className="h-auto w-full cursor-pointer" 
											loading="lazy"
											onClick={() => handleSliderClick(row)}
										/>
									</SwiperSlide>
								))}
							</Swiper>
						)}
					</div>
					{/* list item btn */}
					<div className="mt-4 bg-white p-4 py-2">
						<LiffListItemBtn
							titleIcon="Star"
							title="會員權益"
							linkUrl="https://www.thenorthface.com.tw/page/membership"
						></LiffListItemBtn>
						<hr />
						<LiffListItemBtn
							titleIcon="Store"
							title="門市資訊"
							linkUrl="https://www.thenorthface.com.tw/v2/Shop/StoreList/16525"
						></LiffListItemBtn>
						<hr />
						<LiffListItemBtn
							titleIcon="Mall"
							title="線上商城"
							linkUrl="https://www.thenorthface.com.tw/"
						></LiffListItemBtn>
						<hr />
						<LiffListItemBtn
							titleIcon="About"
							title="關於我們"
							linkUrl="https://www.thenorthface.com.tw/Shop/introduce/16525?t=1&lang=zh-TW"
						></LiffListItemBtn>
					</div>
					<div className="mt-4 h-16 flex-none"></div>
				</div>
			</div>
		</>
	);
};

export default HomePage;
